<template>
  <div class="right_col" role="main" style="min-height: 756px">
    <div class="">
      <div class="page-title">
        <div class="title_left">
          <h3>{{ $t('subMenu.menu') }}</h3>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <div class="row">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="x_panel">
          <div class="x_content">
            <alert
              :title="$t('orderPage.menuDraft')"
              :success-message="$t('common.hasRegistered')"
              :error-message="$t('common.hasNotRegistered')"
              :alerts="alerts"
              :errors="errors"
              :display="isSuccess"
              @closeAlert="closeAlert"
            />
            <div v-if="draftCreate" class="col-md-6 cml-sm-12 col-xs-12">
              <div class="col">
                <button
                  @click="newMenuCreate"
                  type="button"
                  class="btn btn-primary btn-xs col-md-12 col-sm-12 col-xl-12"
                >
                  <h2>{{ $t('orderPage.createNewMenu') }}</h2>
                </button>
              </div>
              <div class="clearfix"></div>
              <div class="col">
                <p>{{ $t('orderPage.copyPublishedMenuNotice') }}</p>
              </div>
            </div>
            <div v-else class="col-md-6 cml-sm-12 col-xs-12">
              <div class="col">
                <router-link
                  to="/order/menu/create"
                  class="btn btn-primary btn-xs col-md-12 col-sm-12 col-xl-12"
                >
                  <h2>{{ $t('orderPage.editDraft') }}</h2>
                </router-link>
              </div>
              <div class="clearfix"></div>
              <div class="col">
                <p>{{ $t('orderPage.editDraftNotice') }}</p>
              </div>
            </div>
            <div v-if="inOperationEdit" class="col-md-6 cml-sm-12 col-xs-12">
              <div class="col">
                <router-link
                  to="/order/menu/edit"
                  class="btn btn-danger btn-xs col-md-12 col-sm-12 col-xl-12"
                >
                  <h2>{{ $t('orderPage.editPublishedMenu') }}</h2>
                </router-link>
              </div>
              <div class="clearfix"></div>
              <div class="col">
                <p>{{ $t('orderPage.editPublishedMenuNotice') }}</p>
              </div>
            </div>
            <div v-else class="col-md-6 cml-sm-12 col-xs-12">
              <div class="col">
                <button
                  type="button"
                  class="btn btn-danger btn-xs col-md-12 col-sm-12 col-xl-12"
                  disabled="disabled"
                >
                  <h2>{{ $t('orderPage.noOpenMenu') }}</h2>
                </button>
              </div>
              <div class="clearfix"></div>
              <div class="col">
                <p>{{ $t('orderPage.createOpenMenu') }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// module
import { mapGetters } from 'vuex'
import Alert from '@/components/common/alert/Alert'

export default {
  components: {
    Alert,
  },
  data() {
    return {
      draftCreate: true,
      inOperationEdit: false,
      alerts: '',
      errors: null,
      isSuccess: false,
    }
  },
  computed: {
    ...mapGetters({
      getDraftMenu: 'menu/getDraftMenu',
      getInOperationMenu: 'menu/getInOperationMenu',
    }),
  },
  watch: {
    getDraftMenu: function(newValue) {
      if (Object.keys(newValue).length > 0) {
        this.draftCreate = false
      }
    },
    getInOperationMenu: function(newValue) {
      if (Object.keys(newValue).length > 0) {
        this.inOperationEdit = true
      }
    },
  },
  created() {
    this.$store.dispatch('menu/fetchMenu')
    this.$store.dispatch('menu/fetchCategories')
    this.$store.dispatch('menu/fetchItems')
  },
  methods: {
    // 新規下書きメニュー登録
    newMenuCreate: function() {
      this.$store.dispatch('menu/createDraft')
      this.alerts = 'success'
      this.isSuccess = true
    },
    closeAlert: function() {
      this.isSuccess = false
    },
  },
}
</script>
